// extracted by mini-css-extract-plugin
export default {"layout":"Index_layout__Ga5sZ","bottom":"Index_bottom__kfZlx"};